import { apiUrl } from '.';
import { authService } from './';


const activityTypeInfo = async (slug) => {
    const requestOptions = { method: 'GET' };
    const res = await authService.handleResponse(apiUrl + '/activities/info/?slug=' + slug, requestOptions);
    return res;
}

const activityAdd = async (data) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(data)
    };
    const res = await authService.handleResponse(apiUrl + '/activities/', requestOptions);
    return res;
}

const activityEditData = async (id) => {
    const requestOptions = { method: 'GET' };
    const res = await authService.handleResponse(apiUrl + '/activities/edit/?id=' + id, requestOptions);
    return res;
}

const activityEdit = async (id, data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };
    const res = await authService.handleResponse(apiUrl + '/activities/edit/?id=' + id, requestOptions);
    return res;
}

const activityList = async (slug, page, sortField, sortOrder, pages = 1) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/activities/?slug='+slug+'&page='+page + (pages > 1 ? '&pages='+pages : '') + (sortField ? '&sortField='+sortField : '') + (sortOrder !== null ? '&sortOrder='+sortOrder : ''), requestOptions);
    return res;
}

const activityItem = async (id) => {
    const requestOptions = { method: 'GET' };
    const res = await authService.handleResponse(apiUrl + '/activities/item/?id=' + id, requestOptions);
    return res;
}

const activitySignup = async (activityId, comments) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({ activityId, comments })
    };
    const res = await authService.handleResponse(apiUrl + '/activities/signup/', requestOptions);
    return res;
}

const activityUnsignup = async (signupId) => {
    const requestOptions = { method: 'DELETE' };
    const res = await authService.handleResponse(apiUrl + '/activities/signup/?id=' + signupId, requestOptions);
    return res;
}

const activityDelete = async (id) => {
    const requestOptions = { method: 'DELETE' };
    const res = await authService.handleResponse(apiUrl + '/activities/?id=' + id, requestOptions);
    return res;
}

export const activityService = {
    activityTypeInfo,
    activityAdd,
    activityEditData,
    activityEdit,
    activityList,
    activityItem,
    activitySignup,
    activityUnsignup,
    activityDelete
};